import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import styles from "../../content/pages/homepage.module.css";
import { useContext, useEffect, useRef, useState } from "react";
import { frontEnvNumber, subscribeFrontRuntimeConfig } from "src/services/runtimeFrontConfig";
import RateLimitDrawer from "src/components/BenchDrawer/RateLimitDrawer";
import { WidgetContext } from "src/contexts/WidgetContext";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { analyzeTrade } from "src/api/analyzeTrade";
import LoaderFacts from "../Loader/Loader";
import { useAuth0 } from "@auth0/auth0-react";
import TradeResponseStream from "./TradeResponseStream";
import { Capacitor } from "@capacitor/core";
import { BackgroundTask } from "@capawesome/capacitor-background-task";
import { base64ToBlob } from "src/utils/audioUtils";
import { useSafeAccessAuth0Token } from "src/hooks/useSafeAccessAuth0Token";
import { trackTradeAnalysis, trackSlowOperation, trackEndpointResponseTime } from "src/utils/analyticsCapFirebase";
import { startPollingForCompletion } from "src/utils/streamPolling";
import { App } from "@capacitor/app";
import { isMobileWebBrowser } from "src/utils/platformUtils";
import { redirectToAuth0NoCredits } from "src/utils/auth0NoCredits";
import { PcmChunkPlayer } from "src/utils/pcmChunkPlayer";
import { STREAMING_AUDIO_SAMPLE_RATE, DEFAULT_AUDIO_CHANNELS } from "src/constants/audioConfig";
import { applyLegacyLipSyncOrSkip, prefetchVegaFromAudioUrl } from "src/lipsync/vegaLipSync";
import { audioService } from "src/services/audioService";
import { getCredits } from "src/api/getCredits";
import { trackCreditConsumed } from "src/utils/analyticsCapFirebase";
// import TradeCreditOptionButton from "./TradeCreditOptionButton";
import { useFreeModelExecutionGate } from "src/hooks/useFreeModelExecutionGate";
// import { CharacterBubbleRef } from "../CharacterViewer/CharacterBubble";
import { CharacterBubble2Ref } from "src/components/CharacterViewer/CharacterBubble2";
import CreditsValueButtons from "../CreditsUi/CreditsValueButtons";

const columns = [
  { id: "name", label: "Name" },
  { id: "team", label: "Team" },
  { id: "pos", label: "Pos" },
  { id: "val", label: "Val" },
];
function TradeGiveReceiveStream({
  onClose,
  goBack,
  teamDisplayName,
  userIdTeam,
  ownerId,
  leagueIdPlatform,
  userDataPlatform,
  rostersData,
  loadingRoster,
  setErrorMessages,
  setShouldPlayAudio,
  aiSettings,
  enableCreditValidation,
  calculatorSettings,
  selectedModel,
  setSelectedModel,
  userSubscription,
  setUserSubscription,
  setIsPaymentOpen,
  setInitialPaymentView,
  setIsBenchDrawerOpen,
  characterRef,
  isExpanded,
  onToggleExpand,
  setThoughtsCommon,
  markSignThoughtsForDrawer,
  clearSignThoughtsDrawerSource,
  isCreditsAnimating,
  creditsBoxRef,
}: {
  onClose: () => void;
  goBack: () => void;
  teamDisplayName: string;
  userIdTeam: string;
  ownerId: string;
  leagueIdPlatform: string;
  userDataPlatform: any;
  rostersData: any;
  loadingRoster: boolean;
  setErrorMessages: (updater: any) => void;
  setShouldPlayAudio: (value: boolean) => void;
  aiSettings: any;
  enableCreditValidation: boolean;
  calculatorSettings: any;
  selectedModel: "RotoGPT 5.0" | "RotoGPT FREE";
  setSelectedModel: (model: "RotoGPT 5.0" | "RotoGPT FREE") => void;
  userSubscription: string;
  setUserSubscription: (subscription: string) => void;
  setIsPaymentOpen: (open: boolean) => void;
  setInitialPaymentView: (view: string) => void;
  // characterRef?: React.RefObject<CharacterEmbedRef>;
  characterRef: React.RefObject<CharacterBubble2Ref>;
  setIsBenchDrawerOpen: (open: boolean) => void;
  isExpanded?: boolean;
  onToggleExpand?: () => void;
  setThoughtsCommon: (thoughts: string) => void;
  markSignThoughtsForDrawer?: (source: "trades" | "DraftAdvice" | "trades-result") => void;
  clearSignThoughtsDrawerSource?: () => void;
  isCreditsAnimating: boolean;
  creditsBoxRef: React.RefObject<HTMLDivElement>;
}) {
  const beginTradeSignThoughts = (text: string) => {
    markSignThoughtsForDrawer?.("trades");
    setThoughtsCommon(text);
  };
  const endTradeSignThoughts = () => {
    setThoughtsCommon("");
    clearSignThoughtsDrawerSource?.();
  };
  // Trade result is now visible: clear sign text and mark drawer source so HomePage hides
  // Quan's sign (user reads/listens to the trade response with lipsync), even if other streams stay active.
  const markTradeResultVisible = () => {
    setThoughtsCommon("");
    markSignThoughtsForDrawer?.("trades-result");
  };

  const [, setFrontRuntimeBump] = useState(0);
  useEffect(() => subscribeFrontRuntimeConfig(() => setFrontRuntimeBump((n) => n + 1)), []);
  const agentEndpointCredits = frontEnvNumber("REACT_APP_AGENT_ENDPOINT_CREDITS", 10);

  // importing the team name from context

  const { yahooToken, sectionData } = useContext(WidgetContext);

  // console.log("0000000TradeGiveReceive leagueIdPlatform:", leagueIdPlatform);
  const { pocToken, commonLeagueLeagueType, userDataCache, selectedTeamInfo, setCredits, credits, setFreeCredits, freeCredits, isLoggedInAuth0ExperienceGlobal, NON_LOGGED_IN_CONFIG, isDrawerOpen } = useContext(WidgetContext);
  const { user, loginWithRedirect } = useAuth0();
  const { getSafeAccessAuth0Token } = useSafeAccessAuth0Token();
  // States to be selected more than one item in the table
  const [selectedFirstRow, setSelectedFirstRow] = useState([]);
  const [selectedSecondRow, setSelectedSecondRow] = useState([]);
  const [tradeResponseData, setTradeResponseData] = useState(null);
  const [showTradeResponse, setShowTradeResponse] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [givePlayers, setGivePlayers] = useState([]);
  const [receivePlayers, setReceivePlayers] = useState([]);
  const [tradeAudioUrl, setTradeAudioUrl] = useState<string | null>(null);

  // --- NEW: States for streaming data ---
  const [streamStatus, setStreamStatus] = useState("");
  const [streamThought, setStreamThought] = useState("");
  const [isGeneratingResult, setIsGeneratingResult] = useState(false);
  const abortControllerRef = useRef<AbortController | null>(null);
  // User tapped back/close during an in-flight stream: skip freeze-recovery polling so they return to the player list.
  const userDismissedInFlightTradeRef = useRef(false);

  // Rate limit drawer - local state (self-contained, no prop drilling needed)
  const [isRateLimitDrawerOpen, setIsRateLimitDrawerOpen] = useState(false);
  const [rateLimitRetryAt, setRateLimitRetryAt] = useState<number | null>(null);

  // Function to update credits after successful endpoint execution
  const updateCreditsAfterEndpoint = async () => {
    try {
      const accessAuthToken = await getSafeAccessAuth0Token();
      if (accessAuthToken) {
        const prevPaid = credits ?? 0;
        const prevFree = freeCredits ?? 0;
        const creditsData = await getCredits(accessAuthToken);
        setCredits(creditsData.credits);
        setFreeCredits(creditsData.freeCredits);
        setUserSubscription(creditsData.subscription);
        const paidDelta = prevPaid - (creditsData.credits ?? 0);
        const freeDelta = prevFree - (creditsData.freeCredits ?? 0);
        if (paidDelta > 0 || freeDelta > 0) {
          const usedPaid = paidDelta > 0;
          const tradeAuthId = isLoggedInAuth0ExperienceGlobal ? user?.sub : NON_LOGGED_IN_CONFIG?.NON_LOGGED_IN_AUTH_ID;
          void trackCreditConsumed(
            tradeAuthId || "unknown",
            usedPaid ? (creditsData.credits ?? 0) : (creditsData.freeCredits ?? 0),
            !!isLoggedInAuth0ExperienceGlobal,
            "trade_analysis",
            usedPaid ? "credits" : "free",
          );
        }
      }
    } catch (error) {
      console.error("Error updating credits after endpoint:", error);
    }
  };

  // Subscription-based model selection (matching Super Analysis + SectionHomePage behavior)
  // const [userSubscription, setUserSubscription] = useState<string>("free");
  const subscriptionIsFree = (userSubscription || "free").toLowerCase() === "free";
  const subscriptionModel: "RotoGPT 5.0" | "RotoGPT FREE" = subscriptionIsFree ? "RotoGPT FREE" : "RotoGPT 5.0";

  // Gate for FREE-model executions (web: drawer/AdSense, native: AdMob)
  const { gate: gateFreeModelExecution, GateDrawer: FreeModelGateDrawer } = useFreeModelExecutionGate();

  // --- NEW: Ref to store active trade request details for polling recovery ---
  const activePollingRequestRef = useRef<{
    requestKey: string;
    give: any[];
    receive: any[];
    modelToUse: "RotoGPT 5.0" | "RotoGPT FREE";
  } | null>(null);

  // --- ADD THESE REFS FOR POLLING ---
  const activeStreamRequests = useRef(new Set<string>());
  // Create a Trade-specific ref that uses leagueIdPlatform (prop) instead of selectedTeamInfo.leagueId
  // This ensures the comparison in streamPolling.ts works correctly
  const currentTeamInfoRef = useRef<{ platformId: string; leagueId: string; teamName: string } | null>(null);
  useEffect(() => {
    // Use leagueIdPlatform from props (Trade-specific) and platformId from selectedTeamInfo
    if (selectedTeamInfo?.platformId && leagueIdPlatform) {
      currentTeamInfoRef.current = {
        platformId: selectedTeamInfo.platformId,
        leagueId: leagueIdPlatform, // Use prop, not selectedTeamInfo.leagueId
        teamName: teamDisplayName,
      };
    } else {
      currentTeamInfoRef.current = null;
    }
  }, [selectedTeamInfo?.platformId, leagueIdPlatform]);
  // --- END POLLING REFS ---

  // Ref to the container of the page
  const containerRef = useRef(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // NEW: State to track pending tool calls (chart generation function in poc)
  const [isWaitingForChart, setIsWaitingForChart] = useState(false);

  // NEW: Live PCM player for trade audio summary (streaming chunks)
  const tradePcmPlayerRef = useRef<PcmChunkPlayer | null>(null);
  const [hasLiveTradeAudio, setHasLiveTradeAudio] = useState(false);
  const isDrawerOpenRef = useRef(isDrawerOpen);
  useEffect(() => {
    isDrawerOpenRef.current = isDrawerOpen;
  }, [isDrawerOpen]);
  const wasTradeDrawerOpenRef = useRef(isDrawerOpen);
  useEffect(() => {
    const wasOpen = wasTradeDrawerOpenRef.current;
    wasTradeDrawerOpenRef.current = isDrawerOpen;
    if (!wasOpen || isDrawerOpen) return;
    // keepMounted drawer: stop speakers only; keep the cached trade result for reopen.
    audioService.stopCurrentAudio();
    if (tradePcmPlayerRef.current) {
      tradePcmPlayerRef.current.stop();
      tradePcmPlayerRef.current = null;
    }
    if (characterRef?.current) characterRef.current.setIsTalking(false);
    setHasLiveTradeAudio(false);
  }, [isDrawerOpen, characterRef]);

  // Function to close the trade response modal and stop audio/stream
  const handleTradeResponseClose = () => {
    userDismissedInFlightTradeRef.current = true;
    setShowTradeResponse(false);
    setIsGeneratingResult(false);
    setIsLoading(false);
    endTradeSignThoughts();
    const requestKey = activePollingRequestRef.current?.requestKey;
    if (requestKey) {
      activeStreamRequests.current.delete(requestKey);
    }
    activePollingRequestRef.current = null;
    // Also abort the stream if the user closes the modal
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    // Stop any audio playing through audioService (WAV summary)
    audioService.stopCurrentAudio();
    // Stop live PCM audio if active
    if (tradePcmPlayerRef.current) {
      tradePcmPlayerRef.current.stop();
      tradePcmPlayerRef.current = null;
    }
    if (characterRef?.current) characterRef.current.setIsTalking(false);
    setHasLiveTradeAudio(false);
    // Reset lip-sync data when closing
    tradeLipSyncChunksRef.current = {};
    tradeLipSyncDataRef.current = null;
  };

  useEffect(() => {
    const unregisterBridge = audioService.registerBackgroundOverlayBridge({
      pause: () => tradePcmPlayerRef.current?.pause(),
      resume: () => tradePcmPlayerRef.current?.resume(),
    });

    // Cleanup function: Cleanup audio/stream when the component unmounts (e.g. when closing the drawer)
    return () => {
      unregisterBridge();
      handleTradeResponseClose();
    };
  }, [characterRef]);

  // Ref to accumulate lip-sync chunks by chunkIndex (same pattern as waiver/start/rundown)
  const tradeLipSyncChunksRef = useRef<Record<number, { start: number; end: number; value: string }[]>>({});
  // Ref to store merged lip-sync data (for character synchronization)
  const tradeLipSyncDataRef = useRef<{ mouthCues: { start: number; end: number; value: string }[] } | null>(null);

  const pick = (obj, keys) => {
    return keys.reduce((acc, key) => {
      if (obj && obj.hasOwnProperty(key)) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  };

  // Helper function to check if trade data is valid for display (similar to SectionHomePage)
  const isTradeDataValidForDisplay = (data: any) => {
    if (!data || !data.context) {
      return false;
    }
    const authId = user?.sub ?? NON_LOGGED_IN_CONFIG?.NON_LOGGED_IN_AUTH_ID;
    return data.context.platformId === selectedTeamInfo?.platformId && data.context.leagueId === leagueIdPlatform && data.context.userId === authId;
  };

  const handleTradeResponseOpen = async (modelOverride?: "RotoGPT 5.0" | "RotoGPT FREE") => {
    // Model selection is subscription-based (matches SectionHomePage)
    // modelOverride is intentionally ignored to avoid per-click model races.
    const modelToUse: "RotoGPT 5.0" | "RotoGPT FREE" = subscriptionModel;
    // Internal signal to avoid re-opening the ad gate after the ad already completed.
    const isPostAdFreeExecution = modelOverride === "RotoGPT FREE";

    // Check if user has credits
    // DEV: Comment enableCreditValidation prop in HomePage to disable this check
    // Only open paywall if user has 0 credits AND no valid cached data
    const hasValidData = isTradeDataValidForDisplay(tradeResponseData);

    // Check freeCredits ONLY if there's no valid data to show (for FREE model users)
    // If there's valid data, allow viewing it even if freeCredits === 0 (user already paid for it)
    if (!hasValidData && userSubscription === "free" && modelToUse === "RotoGPT FREE" && freeCredits <= 9) {
      console.log("[Trade] Opening BenchDrawer: No freeCredits available and no valid data to show");
      // Non-logged out of credits: redirect to Auth0 (no-credits message) instead of BenchDrawer
      if (!isLoggedInAuth0ExperienceGlobal) {
        await redirectToAuth0NoCredits(loginWithRedirect);
        return;
      }
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return; // Exit early, don't start any flow
    }
    // IMPORTANT: Open paywall for premium subscriptions (non-free) with 0 credits.
    // Free subscriptions will use FREE model (with ads), so they don't need paywall here.
    if (enableCreditValidation && credits <= 9 && !hasValidData && modelToUse === "RotoGPT 5.0" && !subscriptionIsFree) {
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return;
    }

    console.log("Using model for trade (subscription):", modelToUse);

    console.log("userIdTeam and ownerIdGR", userIdTeam, ownerId);
    const startTime = Date.now(); // Start timer for initial feedback
    const currentUserDataPlatform = userDataCache[selectedTeamInfo?.platformId];
    console.log("handleTradeResponseOpen userDataPlatform", userDataPlatform);
    console.log("handleTradeResponseOpen currentUserDataPlatform", currentUserDataPlatform);
    // --- TRACK TRADE ANALYSIS EVENT ---
    const platformId = currentUserDataPlatform.integration_name;
    const leagueId = leagueIdPlatform;
    const teamName = teamDisplayName;
    const authId = user?.sub ?? NON_LOGGED_IN_CONFIG?.NON_LOGGED_IN_AUTH_ID ?? "unknown";
    const swid = currentUserDataPlatform.swid;
    const espn_s2 = currentUserDataPlatform.s2;

    await trackTradeAnalysis(authId, platformId, leagueId, teamName);

    // --- THIS ENTIRE FUNCTION IS REBUILT FOR STREAMING ---

    let taskId: string;
    // Only run background task on native platforms
    if (Capacitor.isNativePlatform()) {
      try {
        taskId = await BackgroundTask.beforeExit(async () => {
          // This callback runs immediately.
          // It should NOT contain any logic that disrupts the main flow.
          // Its only purpose here is to initiate the background task with the OS.
          console.log("Background task permission requested.");
        });
      } catch (e) {
        console.error("Failed to start background task", e);
      }
    }

    // Gate FREE model execution behind ads (web drawer / native AdMob)
    if (modelToUse === "RotoGPT FREE" && !isPostAdFreeExecution) {
      void gateFreeModelExecution(() => {
        void handleTradeResponseOpen("RotoGPT FREE");
      });
      return;
    }

    userDismissedInFlightTradeRef.current = false;
    setIsLoading(true);
    // setShouldPlayAudio(false);

    // Prepare give and receive data outside try block so they're available in catch
    const keysToPick = ["name", "position", "team", "age", "dtc_points"];
    const processData = (items: any[]) => {
      return items.map((item) => {
        const pickedData = pick(item, keysToPick);
        pickedData.type = item.hasOwnProperty("player_id") ? "Player" : "Pick";
        const rawId = item.player_id || item.id;
        pickedData.player_id = (rawId && /^\d+$/.test(rawId.toString())) ? parseInt(rawId.toString()) : rawId || null;
        pickedData.player_value = item.player_value || item.draft_pick_value || 0;
        pickedData.position = item.position || null;
        pickedData.age = item.age || null;
        pickedData.team = item.team || null;
        return pickedData;
      });
    };
    const give = processData(selectedFirstRow);
    const receive = processData(selectedSecondRow);
    setGivePlayers(give);
    setReceivePlayers(receive);

    // Create requestKey for tracking polling (NOT for preventing duplicates)
    const playersToGive = selectedFirstRow.map((p) => (p.player_id || p.id)?.toString() || "").filter(Boolean);
    const playersToReceive = selectedSecondRow.map((p) => (p.player_id || p.id)?.toString() || "").filter(Boolean);
    const requestKey = `${authId}-trade-${leagueIdPlatform}-${playersToGive.join("-")}-${playersToReceive.join("-")}`;

    // Store the details for polling recovery
    activePollingRequestRef.current = { requestKey, give, receive, modelToUse };

    // >>> PASO 1: Implementar la bandera de control
    let pollingIsResponsibleForCleanup = false;

    try {
      // >>> PASO 2: Registrar la petición para que el listener de background la encuentre
      activeStreamRequests.current.add(requestKey);

      const accessTokenFromAuth0 = await getSafeAccessAuth0Token();
      if (!accessTokenFromAuth0) {
        setIsLoading(false);
        endTradeSignThoughts();
        return;
      }

      // 2. Reset all stream-related states for the new request
      setStreamStatus("");
      setStreamThought("");
      setIsGeneratingResult(false);
      setTradeAudioUrl(null); // Reset audio blob for the new trade
      // Critical: second run may be cache-only (no PCM chunks); if this stayed true from a prior live stream, TradeResponseStream would skip URL playback (hasLiveTradeAudio guard).
      setHasLiveTradeAudio(false);
      // Initialize with a structure that can hold both text and an array of charts
      setTradeResponseData({ trade_analysis: "", chart_data: [], messageId: null, model: undefined });
      // Reset lip-sync chunks for new trade request
      tradeLipSyncChunksRef.current = {};
      tradeLipSyncDataRef.current = null;

      // Same pattern as waiver: immediate sign text while waiting for first backend thought
      beginTradeSignThoughts("Loading...");

      // 3. Abort any previous request, then create a new AbortController
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();
      const signal = abortControllerRef.current.signal;

      const userId = currentUserDataPlatform.user_id;
      // const userId = userDataPlatform.user_id;
      const leagueId = leagueIdPlatform;

      // console.log("Trade analysis params:", {
      //   isYahoo: !!yahooToken,
      //   userId,
      //   leagueId,
      //   yahooToken,
      // });
      // console.log("leagueId Trade analysis", leagueId);

      // 4. Call the new streaming-enabled analyzeTrade function
      const response = await analyzeTrade(
        userId,
        leagueId,
        give,
        receive,
        swid,
        espn_s2,
        rostersData,
        currentUserDataPlatform,
        pocToken,
        accessTokenFromAuth0,
        yahooToken,
        commonLeagueLeagueType,
        signal,
        userIdTeam, // competitor_team_id
        ownerId, // competitor_owner_id,
        aiSettings.audio,
        calculatorSettings,
        modelToUse,
        isLoggedInAuth0ExperienceGlobal ? user?.sub : NON_LOGGED_IN_CONFIG?.NON_LOGGED_IN_AUTH_ID
      );

      // >>> PASO 3: Lógica de "INCOMPLETE"
      if (response === "INCOMPLETE") {
        console.log("Trade analysis stream received INCOMPLETE. Starting polling.");
        pollingIsResponsibleForCleanup = true; // El polling ahora es responsable

        const contextAtRequestStart = { platformId: selectedTeamInfo?.platformId, leagueId: leagueIdPlatform, userId: authId };

        startPollingForTradeAnalysisCompletion(undefined, requestKey, contextAtRequestStart, {
          give,
          receive,
          competitorTeamId: userIdTeam,
          competitorOwnerId: ownerId,
          modelToUse,
        }, currentUserDataPlatform); // No usamos .finally() aquí, el polling gestiona su propio ciclo

        return; // Salimos para que `finally` no limpie el lock
      }
      // --- END: POLLING LOGIC ---

      // Type guard: ensure response is Response type, not a different string.
      if (!response) {
        if (response === undefined) return; // Aborted, error handled in catch block
        throw new Error("Streaming request failed");
      } else if (typeof response === "string") {
        // This should not happen now due to the lock, but as a safeguard:
        throw new Error(`Unexpected error response`);
      } else if (!response.body) {
        throw new Error("Streaming request failed - no body");
      }

      // Update credits/freeCredits after successful trade execution
      // Premium models consume credits, FREE model consumes freeCredits
      updateCreditsAfterEndpoint();

      // 5. Setup stream reading logic
      const reader = response.body.getReader(); // Get the reader to pull data chunks from the stream.
      const decoder = new TextDecoder(); // The decoder turns the binary chunks (Uint8Array) into text strings.
      let buffer = ""; // This buffer accumulates chunks until a complete message is formed.

      // --- NEW: Local flags for robust state transition ---
      // This flag prevents race conditions and stale state issues inside the stream loop.
      let hasSwitchedToResult = false;
      let firstChunkReceived = false; // Flag to track the first data event
      // NUEVO: flags para coordinar cuándo pasar de "thoughts" a la vista de resultado (texto + audio)
      let hasFirstTextChunk = false;
      let hasFirstAudioChunk = false;
      let tradeFromRedisCache = false;

      const maybeSwitchToResult = () => {
        if (hasSwitchedToResult) return;
        // Siempre requerimos al menos un text_chunk
        if (!hasFirstTextChunk) return;
        // Si el audio está habilitado, también requerimos al menos un audio_summary_chunk no vacío
        if (aiSettings?.audio && !hasFirstAudioChunk) return;

        hasSwitchedToResult = true;
        setIsGeneratingResult(true); // Tell the UI to switch to the results panel.
        setStreamStatus(""); // Clear the transient status.
        setStreamThought(""); // Clear the transient thought.
        markTradeResultVisible(); // Trade result visible → hide sign so user reads/listens
      };

      // This function runs in a loop to read the stream until it's complete.
      const readStream = async () => {
        while (true) {
          const { done, value } = await reader.read();
          // If the stream is finished, the `done` flag will be true.
          if (done) {
            // Fallback: si hubo texto pero nunca se llegó a cumplir la condición
            // de texto + (opcional) audio, igual mostrar el resultado al terminar.
            if (!hasSwitchedToResult && hasFirstTextChunk) {
              hasSwitchedToResult = true;
              setIsGeneratingResult(true);
              setStreamStatus("");
              setStreamThought("");
              markTradeResultVisible();
            }
            setIsLoading(false); // End loading state ONLY when stream is finished
            // Only clear sign if we never reached the result (otherwise keep the result-hide marker).
            if (!hasSwitchedToResult) endTradeSignThoughts();
            if (!tradeFromRedisCache) {
              const durationSeconds = (Date.now() - startTime) / 1000;
              console.log("[endpoint_response_time]", "trade", durationSeconds);
              void trackEndpointResponseTime(authId, "trade", durationSeconds, platformId, leagueId);
            }
            break; // Exit the loop.
          }

          // Decode the chunk and add it to the buffer.
          buffer += decoder.decode(value, { stream: true });
          const messages = buffer.split("\n\n"); // SSE messages are separated by double newlines.
          buffer = messages.pop() || ""; // Keep any incomplete message at the end of the buffer for the next chunk.

          // Process each complete message.
          for (const message of messages) {
            if (!message.startsWith("data:")) continue;

            try {
              // Extract the JSON payload from the message
              const rawData = message.substring(5).trim();
              if (!rawData) continue;

              const event = JSON.parse(rawData);

              // When the first significant message arrives, show the response component.
              if (!firstChunkReceived) {
                firstChunkReceived = true;
                setShowTradeResponse(true);
              }

              // Handle the event based on its type from our backend
              switch (event.type) {
                case "cache_status":
                  tradeFromRedisCache = Boolean(event?.payload?.fromCache);
                  break;
                case "status":
                  // Only track slow operation on the very first status message.
                  if (event.payload === "Starting conversation with RotoGPT...") {
                    const durationSeconds = (Date.now() - startTime) / 1000;
                    if (durationSeconds > 30) {
                      void trackSlowOperation(authId, "fetch_trade", durationSeconds, platformId, leagueId, teamName);
                    }
                  }

                  // Only update the status if we haven't switched to showing the main result.
                  if (!hasSwitchedToResult) setStreamStatus(event.payload);
                  break;

                case "thought": {
                  // Only update the thought if we haven't switched to showing the main result.
                  if (!hasSwitchedToResult) {
                    const header = (event.payload as string).split("\n")[0];
                    setStreamThought(header);
                    beginTradeSignThoughts(header);
                  }
                  break;
                }

                case "text_chunk":
                  // This block runs for every text chunk.
                  // Marcar que ya llegó al menos un text_chunk
                  hasFirstTextChunk = true;
                  // Intentar pasar a la vista de resultado (respetando gating con audio)
                  maybeSwitchToResult();
                  // Clear waiting state when text arrives
                  setIsWaitingForChart(false);

                  // Append the text chunk to our main data state.
                  setTradeResponseData((prev) => ({
                    ...prev,
                    trade_analysis: (prev?.trade_analysis || "") + event.payload,
                  }));
                  break;

                // case "final_text":
                //   hasFirstTextChunk = true;
                //   maybeSwitchToResult();
                //   setIsWaitingForChart(false);
                //   setTradeResponseData((prev) => ({
                //     ...prev,
                //     trade_analysis: event.payload,
                //   }));
                //   break;

                case "chart_data":
                  // When chart data arrives:
                  // 1. Inject a unique placeholder into the text stream.
                  // 2. Add the new chart object to the chart_data array.
                  // Clear waiting state when chart arrives
                  setIsWaitingForChart(false);

                  setTradeResponseData((prev) => {
                    // const chartIndex = prev.chart_data.length; // OLD LOGIC
                    return {
                      ...prev,
                      // The text already contains the correct [CHART:key] placeholders from the 'text_chunk' event.
                      // We no longer need to add artificial placeholders like [chart_0].
                      // trade_analysis: (prev.trade_analysis || "") + `[chart_${chartIndex}]`, // OLD LOGIC
                      chart_data: [...(prev.chart_data || []), event.payload],
                    };
                  });
                  break;

                // case "messageId":
                //   setTradeResponseData((prev) => ({
                //     ...prev,
                //     messageId: event.payload,
                //   }));
                //   break;

                case "tool_call":
                  // Set waiting state when tool call arrives (chart generation starting)
                  setIsWaitingForChart(true);

                  // If we get a tool call, we should be in the result-generating view.
                  // This handles cases where a tool_call might be the first significant event.
                  // Para el nuevo flow, solo cambiamos a la vista de resultado cuando
                  // se cumpla la condición de texto + (opcional) audio, así que NO
                  // forzamos aquí el cambio de estado.
                  // if (!hasSwitchedToResult) {
                  //   hasSwitchedToResult = true;
                  //   setIsGeneratingResult(true);
                  //   setStreamStatus("");
                  //   setStreamThought("");
                  // }
                  break;
                case "share_url":
                  console.log("Received share_url from POC:", event.payload);
                  setTradeResponseData((prev) => ({
                    ...prev,
                    share_url: event.payload,
                  }));
                  break;

                case "lipsync_data": {
                  // Store chunks by chunkIndex and merge in ascending order (chunks may arrive 3,2,1,0)
                  const payload = event.payload || {};
                  const chunkIndex = payload.chunkIndex;
                  const mouthCues = payload.mouthCues || [];
                  const currentMergedCount = Object.keys(tradeLipSyncChunksRef.current).length
                    ? Object.keys(tradeLipSyncChunksRef.current).map(Number).sort((a, b) => a - b).flatMap((k) => tradeLipSyncChunksRef.current[k] ?? []).length
                    : 0;
                  if (chunkIndex === 0) {
                    console.log(`[LipSyncDebug] Trade: CLIENT_RECEIVED first lipsync_data chunkIndex=0 cues=${mouthCues.length}`);
                  }
                  console.log(`[Trade Stream] lipsync_data chunkIndex=${chunkIndex} payloadCues=${mouthCues.length} currentMergedCues=${currentMergedCount}`);
                  if (chunkIndex === undefined) {
                    // We no longer expect a full replacement from backend; keep accumulated cues
                    if (mouthCues.length > 0) {
                      console.warn(
                        `[Trade Stream] Ignoring lipsync_data without chunkIndex (backend sent ${mouthCues.length} cues, we have ${currentMergedCount} merged) – using accumulated chunk cues only`,
                      );
                    }
                  } else {
                    tradeLipSyncChunksRef.current[chunkIndex] = mouthCues;
                    const keys = Object.keys(tradeLipSyncChunksRef.current).map(Number).sort((a, b) => a - b);
                    const mergedCues = keys.flatMap((k) => tradeLipSyncChunksRef.current[k] ?? []);
                    const merged = { mouthCues: mergedCues };
                    tradeLipSyncDataRef.current = merged;
                    console.log(`[Trade Stream] Merged chunks [${keys.join(",")}] → ${mergedCues.length} cues`);
                    // Update character with merged cues immediately (playback may have already started)
                    // This ensures new chunks are available for viseme lookup as they arrive
                    if (characterRef?.current) {
                      console.log(`[LipSyncDebug] Trade: CHARACTER_VISEMAS_APPLIED cues=${mergedCues.length}`);
                      applyLegacyLipSyncOrSkip(characterRef.current, merged, "Trade lipsync_data");
                    }
                  }
                  break;
                }
                case "audio_summary_chunk": {
                  const payload = event.payload || event;
                  const base64Data = payload?.data || payload;
                  const mimeType = payload?.mimeType || payload?.mime_type || "audio/pcm";
                  if (typeof base64Data === "string" && base64Data.length > 0) {
                    // Marcar que llegó al menos un audio_summary_chunk válido
                    hasFirstAudioChunk = true;
                    // Intentar pasar a la vista de resultado (texto + audio listo)
                    maybeSwitchToResult();
                    // Start or reuse live PCM player for trade audio
                    if (!tradePcmPlayerRef.current) {
                      if (!isDrawerOpenRef.current) {
                        break;
                      }
                      console.log("[Trade Live Audio] First audio_summary_chunk received, creating PcmChunkPlayer");
                      // Stop any existing high-priority audio (welcome / other summaries) before starting live trade audio
                      audioService.stopCurrentAudio();
                      if (characterRef?.current) characterRef.current.setIsTalking(false);
                      tradePcmPlayerRef.current = new PcmChunkPlayer({
                        sourceSampleRate: STREAMING_AUDIO_SAMPLE_RATE,
                        channels: 1,
                        label: "trade",
                        vegaCharacterRef: characterRef,
                        onPlaybackStarted: () => {
                          console.log("[LipSyncDebug] Trade: PCM_PLAYBACK_STARTED");
                          // Use merged chunks from ref so we don't overwrite with stale data (React batching)
                          if (characterRef?.current) {
                            const chunks = tradeLipSyncChunksRef.current;
                            const keys = Object.keys(chunks).map(Number).sort((a, b) => a - b);
                            const mergedCues = keys.length > 0 ? keys.flatMap((k) => chunks[k] ?? []) : (tradeLipSyncDataRef.current?.mouthCues ?? []);
                            const data = { mouthCues: mergedCues };
                            tradeLipSyncDataRef.current = data;
                            console.log(`[LipSyncDebug] Trade: CHARACTER_VISEMAS_APPLIED onPlaybackStarted cues=${mergedCues.length}`);
                            applyLegacyLipSyncOrSkip(characterRef.current, data, "Trade onPlaybackStarted");
                            characterRef.current.setPlaybackStartTime(performance.now() / 1000);
                            characterRef.current.setIsTalking(true);
                            console.log("[Trade Stream] Playback started - syncing lipsync with", mergedCues.length, "cues");
                          }
                        },
                        onPlaybackEnded: () => {
                          // Stop talking animation when PCM playback ends
                          if (characterRef?.current) {
                            console.log("[Trade Stream] Playback ended - stopping talking animation");
                            characterRef.current.setIsTalking(false);
                          }
                        },
                      });
                      try {
                        await tradePcmPlayerRef.current.start();
                      } catch (e) {
                        console.error("[Trade Live Audio] Failed to start PcmChunkPlayer", e);
                      }
                      setHasLiveTradeAudio(true);
                    }
                    try {
                      tradePcmPlayerRef.current?.addChunkBase64(base64Data, mimeType);
                    } catch (e) {
                      console.error("[Trade Live Audio] Failed to add PCM chunk to player", e);
                    }
                  }
                  break;
                }
                case "audio_summary":
                  console.log("[LipSyncDebug] Trade: CLIENT_RECEIVED audio_summary (endpoint has URL)");
                  // --- TIMING LOG for network delivery ---
                  if (event.timestamp) {
                    const networkTime = Date.now() - event.timestamp;
                    const seconds = networkTime / 1000;
                    console.log(`[Trade Audio] Network delivery took ${seconds.toFixed(2)}s.`);
                  }
                  // This is the final audio URL (from POC or assembled in backend)
                  console.log("Received trade audio summary URL event.");
                  // Do NOT auto-play here if live PCM audio has already been playing.
                  setTradeAudioUrl(event.payload);
                  prefetchVegaFromAudioUrl(typeof event.payload === "string" ? event.payload : null);
                  break;

                case "complete":
                  // This event now signals the end of all data from the backend.
                  console.log("Stream complete event received from backend.");
                  if (event?.payload?.fromCache) tradeFromRedisCache = true;
                  tradePcmPlayerRef.current?.signalEndOfPcmStream();
                  // Extract and store the messageId from the complete event payload
                  if (event.payload?.messageId) {
                    setTradeResponseData((prev) => ({
                      ...prev,
                      messageId: event.payload.messageId,
                      model: modelToUse, // Store which model generated this response (for UI rendering, NOT polling)
                    }));
                  }
                  setIsLoading(false); // End loading state ONLY when stream is finished
                  // Keep the result-hide marker if we already switched to result; otherwise clear.
                  if (!hasSwitchedToResult) endTradeSignThoughts();
                  // // Update credits after successful trade execution
                  // updateCreditsAfterEndpoint();
                  break;

                case "api_error": {
                  // If we receive an error from the stream, stop everything and show an error.
                  console.error("Stream API Error:", event.payload);
                  setErrorMessages((prev) => ({
                    ...prev,
                    "Analyze Trade": event.payload,
                  }));
                  setShowTradeResponse(false);
                  setIsLoading(false);
                  endTradeSignThoughts();
                  // Refresh credits UI with a small delay to ensure backend Mongo refund completes first
                  setTimeout(() => { void updateCreditsAfterEndpoint(); }, 1500);
                  abortControllerRef.current?.abort(); // Abort to stop processing.
                  return; // Exit the readStream function immediately.
                }

                default:
                  // Handle any unknown event types gracefully.
                  console.warn("Unknown event type:", event.type);
                  break;
              }
            } catch (e) {
              console.error("Failed to parse stream data:", e, { message });
            }
          }
        }
      };
      // setTradeResponseData(response);
      // setShowTradeResponse(true);
      // Start reading the stream and catch any errors that might occur during the process.
      await readStream();
    } catch (error) {
      // If stream fails, clear stale thought bubble/sign immediately.
      endTradeSignThoughts();
      // >>> PASO 4: Lógica de CATCH robusta
      // Rate limit: open drawer instead of breaking the UI
      if ((error as any).isRateLimit) {
        const retryAfterSeconds = (error as any).retryAfter ?? 60;
        setRateLimitRetryAt(Date.now() + retryAfterSeconds * 1000);
        setIsRateLimitDrawerOpen(true);
        setErrorMessages((prev) => ({ ...prev, "Analyze Trade": "Too many requests. Try again later." }));
        setShowTradeResponse(false);
        setIsLoading(false);
        endTradeSignThoughts();
        return;
      }
      // User tapped back/close during the in-flight stream: return to the player list, do not start recovery polling.
      if (userDismissedInFlightTradeRef.current) {
        setIsLoading(false);
        setShowTradeResponse(false);
        setIsGeneratingResult(false);
        return;
      }
      // Si es un error de red o aborto, el polling debe tomar el control
      if (error.name === "AbortError" || error.name === "TypeError") {
        console.log("Trade analysis request aborted or failed (freeze bug), starting recovery poll.");
        pollingIsResponsibleForCleanup = true; // El polling ahora es responsable

        const contextAtRequestStart = { platformId: selectedTeamInfo?.platformId, leagueId: leagueIdPlatform, userId: authId };
        startPollingForTradeAnalysisCompletion(undefined, requestKey, contextAtRequestStart, {
          give,
          receive,
          competitorTeamId: userIdTeam,
          competitorOwnerId: ownerId,
          modelToUse,
        }, currentUserDataPlatform);

        return; // Salimos para que no se ejecute la lógica de error fatal
      }

      // Si llegamos aquí, es un error fatal (del backend, etc.)
      console.error("Error analyzing trade", error);
      setErrorMessages((prev) => ({ ...prev, "Analyze Trade": error.message }));
      setShowTradeResponse(false);
      setIsLoading(false); // Detenemos el loading porque la operación falló definitivamente
      endTradeSignThoughts();
      // Refresh credits UI with a small delay to ensure backend Mongo refund completes first
      setTimeout(() => { void updateCreditsAfterEndpoint(); }, 1500);
    } finally {
      // >>> PASO 5: Lógica de FINALLY condicional
      if (!pollingIsResponsibleForCleanup) {
        activeStreamRequests.current.delete(requestKey);
        activePollingRequestRef.current = null; // Also clean up here
      }

      // Finish the background task if it's running
      if (Capacitor.isNativePlatform() && taskId) {
        console.log(`Finishing background task in finally: ${taskId}`);
        BackgroundTask.finish({ taskId });
      }
    }
  };

  // Function to close the trade response modal and stop audio/stream is now defined above with the useEffect

  // X on TradeResponseStream used to call onClose only — live PCM is stopped in handleTradeResponseClose (goBack path).
  const handleCloseTradeModal = () => {
    handleTradeResponseClose();
    onClose();
  };

  // Wrapper for onClose to ensure audio and stream are stopped when closing the drawer from the builder or LoaderFacts
  const handleDrawerClose = () => {
    handleTradeResponseClose();
    onClose();
  };

  //Information partners for the 6 cards from teamsTrade
  const informationPartners = [
    { text: `${rostersData?.league_info?.league_size || "-"} Teams` },
    { text: "PPR", cardsOn: rostersData?.league_info?.league_format === "ppr" },
    { text: "SF", cardsOn: rostersData?.league_info?.settings?.superflex },
    { text: "TE+", cardsOn: rostersData?.league_info?.settings?.TE_Premium },
    { text: "RB PPC", cardsOn: rostersData?.league_info?.settings?.RB_PPC },
    { text: "IDP", cardsOn: false },
  ];

  //Function to select more than one element of the first row
  const handleClickFirstRow = (item) => {
    if (item.player_id) {
      if (selectedFirstRow.some((p) => p.player_id === item.player_id)) {
        setSelectedFirstRow(selectedFirstRow.filter((p) => p.player_id !== item.player_id));
      } else {
        setSelectedFirstRow([...selectedFirstRow, item]);
      }
    } else {
      if (selectedFirstRow.some((p) => p.id === item.id)) {
        setSelectedFirstRow(selectedFirstRow.filter((p) => p.id !== item.id));
      } else {
        setSelectedFirstRow([...selectedFirstRow, item]);
      }
    }
  };

  //Function to select more than one element of the second row
  const handleClickSecondRow = (item) => {
    if (item.player_id) {
      if (selectedSecondRow.some((p) => p.player_id === item.player_id)) {
        setSelectedSecondRow(selectedSecondRow.filter((p) => p.player_id !== item.player_id));
      } else {
        setSelectedSecondRow([...selectedSecondRow, item]);
      }
    } else {
      if (selectedSecondRow.some((p) => p.id === item.id)) {
        setSelectedSecondRow(selectedSecondRow.filter((p) => p.id !== item.id));
      } else {
        setSelectedSecondRow([...selectedSecondRow, item]);
      }
    }
  };

  // Check if tables have at least one element selected
  const isTradeReady = selectedFirstRow.length > 0 && selectedSecondRow.length > 0;

  const selectedCompetitorTeam = rostersData?.competitor_teams?.find((team) => team.team_id === userIdTeam);

  const getNameWithSuspensivePoints = (fullName) => {
    if (fullName?.length > 17 && isMobile) {
      return `${fullName.substring(0, 17)}...`;
    }
    return fullName;
  };

  // Function to format the value to 2 decimal place
  const formatValue = (value: number) => {
    const formatted = Number(value).toFixed(2);
    return formatted === "0.00" ? "0" : formatted;
  };

  // Function to scroll to the top of the page
  const scrollToTop = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    scrollToTop();
  }, []);

  // Function to start polling for trade analysis completion
  const startPollingForTradeAnalysisCompletion = async (
    signal: AbortSignal | undefined,
    requestKey: string,
    context: { platformId: string; leagueId: string; userId: string | undefined },
    apiCallArgs: {
      give: any[];
      receive: any[];
      competitorTeamId?: string;
      competitorOwnerId?: string;
      modelToUse?: "RotoGPT 5.0" | "RotoGPT FREE";
    },
    platformDataOverride?: any
  ) => {
    const currentUserDataPlatform = platformDataOverride ?? userDataCache[context.platformId];
    const authId = user?.sub ?? NON_LOGGED_IN_CONFIG?.NON_LOGGED_IN_AUTH_ID ?? "unknown";
    const userId = currentUserDataPlatform.user_id;
    console.log("Polling started for trade analysis completion.");
    try {
      await startPollingForCompletion({
        endpointType: "analyze_trade",
        leagueId: leagueIdPlatform,
        teamName: teamDisplayName,
        yahooToken,
        signal,
        context,
        currentTeamInfoRef,
        requestKey,
        activeStreamRequests,
        apiCallArgs,
        getAccessTokenSilently: getSafeAccessAuth0Token,
        authId,
        currentUserDataPlatform,
        pocToken,
        apiCall: (authId, currentUserDataPlatform, leagueId, _teamName, pocToken, accessToken, signal, yahooToken, apiCallArgs) =>
          analyzeTrade(
            currentUserDataPlatform.user_id, // FIX: Pass the platform-specific user_id, not the authId
            leagueId,
            apiCallArgs.give,
            apiCallArgs.receive,
            currentUserDataPlatform.swid,
            currentUserDataPlatform.s2,
            rostersData,
            currentUserDataPlatform,
            pocToken,
            accessToken,
            yahooToken,
            commonLeagueLeagueType,
            signal,
            apiCallArgs.competitorTeamId, // Use from apiCallArgs instead of userIdTeam
            apiCallArgs.competitorOwnerId, // Use from apiCallArgs instead of ownerId
            aiSettings.audio, // Add audioSettings
            calculatorSettings, // Add calculatorSettings
            apiCallArgs.modelToUse || selectedModel // Use stored model when available
          ),
        setStreamState: (updater) => {
          const newState = updater({ status: streamStatus, thought: streamThought, isGeneratingResult });
          setStreamStatus(newState.status || "");
          setStreamThought(newState.thought || "");
          // Sticky: once the result is visible, polling errors must NOT hide it
          // (otherwise LoaderFacts flashes back over the already-rendered trade response)
          setIsGeneratingResult((prev) => newState.isGeneratingResult || prev);
        },
        setData: (data) => {
          setTradeResponseData(data);
          setShowTradeResponse(true);
          endTradeSignThoughts();
        },
        setLoading: setIsLoading,
        updateSectionData: () => { }, // Not applicable for trade
        setEndpointErrors: () => { }, // Not applicable for trade
        setErrorMessages,
        setHasAnimationCompleted: () => { }, // No animation to skip
        retrievingMessage: "Retrieving your trade analysis...",
        errorKey: "Analyze Trade",
        setThoughtsCommon: (text: string) => {
          if (!text) endTradeSignThoughts();
          else beginTradeSignThoughts(text);
        },
        onAudioUrl: (url) => {
          setHasLiveTradeAudio(false);
          if (tradePcmPlayerRef.current) {
            tradePcmPlayerRef.current.stop();
            tradePcmPlayerRef.current = null;
          }
          setTradeAudioUrl(url);
          prefetchVegaFromAudioUrl(url);
        },
      });
    } catch (error) {
      console.error("Polling for trade analysis completion failed:", error);
      setIsLoading(false);
      endTradeSignThoughts();
      setErrorMessages((prev) => ({ ...prev, "Analyze Trade": "Polling failed to retrieve trade analysis." }));
    }
  };

  // Function to listen for app state changes
  useEffect(() => {
    // This entire recovery mechanism is only for mobile platforms.
    if (!Capacitor.isNativePlatform() && !isMobileWebBrowser()) {
      return;
    }
    let listener: any;
    let visibilityListener: () => void;

    // Helper function to re-trigger polling when app/tab becomes visible
    const reTriggerPollingIfNeeded = () => {
      // We check if we are in a loading state AND the stream is not currently active.
      // This is the true sign that polling needs to take over.
      if (!isLoading || isGeneratingResult) {
        return;
      }

      // --- FIX: Use the stored request details from the ref ---
      if (!activePollingRequestRef.current) {
        console.warn("Polling re-trigger attempted, but no active request details found.");
        return;
      }

      const { requestKey, give, receive, modelToUse } = activePollingRequestRef.current;

      if (activeStreamRequests.current.has(requestKey)) {
        console.log("Trade Analysis was loading. Re-triggering POLLING to check status.");

        // CRITICAL FIX: Set the status message BEFORE starting polling
        // This ensures TradeResponseStream shows "Retrieving your trade analysis..." immediately
        setStreamStatus("Retrieving your trade analysis...");
        setStreamThought(""); // Clear any previous thought to ensure status is shown
        beginTradeSignThoughts("Retrieving your trade analysis...");
        // setIsGeneratingResult(false); // Reset to show loader instead of results view

        const currentUserDataPlatform = userDataCache[selectedTeamInfo?.platformId];
        const contextAtRequestStart = {
          platformId: selectedTeamInfo?.platformId,
          leagueId: leagueIdPlatform,
          userId: user?.sub,
        };

        startPollingForTradeAnalysisCompletion(undefined, requestKey, contextAtRequestStart, {
          give, // Use stored value
          receive, // Use stored value
          competitorTeamId: userIdTeam,
          competitorOwnerId: ownerId,
          modelToUse,
        }, currentUserDataPlatform).finally(() => {
          activeStreamRequests.current.delete(requestKey);
          activePollingRequestRef.current = null; // Clean up after polling is done
          console.log(`Polling (from background) for ${requestKey} finished. Lock released.`);
        });
      }
    };

    // For native platforms
    const setupNativeListener = async () => {
      if (!Capacitor.isNativePlatform()) {
        return;
      }

      listener = await App.addListener("appStateChange", ({ isActive }) => {
        if (isActive) {
          console.log("App returned from background. Re-triggering checks for incomplete trade analysis.");
          reTriggerPollingIfNeeded();
        }
      });
    };

    // // For web mobile (Chrome/Safari on mobile)
    const setupWebMobileListener = () => {
      if (Capacitor.isNativePlatform()) {
        return;
      }

      visibilityListener = () => {
        if (document.visibilityState === "visible") {
          console.log("Tab became visible. Re-triggering checks for incomplete trade analysis.");
          reTriggerPollingIfNeeded();
        }
      };

      document.addEventListener("visibilitychange", visibilityListener);
    };

    setupNativeListener();
    setupWebMobileListener();

    return () => {
      if (listener && listener.remove) {
        listener.remove();
      }
      if (visibilityListener) {
        document.removeEventListener("visibilitychange", visibilityListener);
      }
    };
  }, [isLoading, isGeneratingResult, leagueIdPlatform, user?.sub, userIdTeam, ownerId]);


  const leagueTypeContent = sectionData?.commonLeagueData?.league_info?.league_type;
  const isLeagueTypeRedraft = typeof leagueTypeContent === "string" && leagueTypeContent.trim().toLowerCase() === "redraft";

  // Redraft leagues: draft picks are not tradeable — drop any pick already in selection state.
  useEffect(() => {
    if (!isLeagueTypeRedraft) return;
    setSelectedFirstRow((prev) => prev.filter((item) => item.player_id));
    setSelectedSecondRow((prev) => prev.filter((item) => item.player_id));
  }, [isLeagueTypeRedraft]);

  return (
    <div
      ref={containerRef}
      style={{
        height: "100%",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        scrollBehavior: "smooth",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      className={styles.noScrollbar}
    >
      {/* Shared ad gate drawer for FREE trade executions */}
      <FreeModelGateDrawer />
      {/* Trade builder + LoaderFacts until first result text; then TradeResponseStream. Thoughts-only phase keeps LoaderFacts (sign shows thoughts via thoughtsCommon). */}
      {!showTradeResponse ? (
        isLoading ? (
          <LoaderFacts
            onClose={handleDrawerClose}
            goBack={goBack}
            showExpandToggle={Boolean(aiSettings?.quan)}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
          />
        ) : (
          <Stack direction="column" spacing={0} sx={{ width: "100%", bgcolor: `${PureLightThemeCaaS.colors.alpha.black[100]}`, paddingBottom: "env(safe-area-inset-bottom)" }}>
            <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" p={1}>
              <IconButton aria-label="close" onClick={goBack}>
                <ArrowBackIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }} />
              </IconButton>
              <Typography variant="h4" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} textAlign={"center"} className={styles.tradeTeam}>
                {/* dynamic team name */}
                Trade with {teamDisplayName}
              </Typography>
              <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center">
                {onToggleExpand && aiSettings?.quan && (
                  <IconButton aria-label="toggle-expand" onClick={onToggleExpand}>
                    {isExpanded ? (
                      <KeyboardArrowDownIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }} />
                    ) : (
                      <KeyboardArrowUpIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }} />
                    )}
                  </IconButton>
                )}
                <IconButton aria-label="close" onClick={handleDrawerClose}>
                  <CloseIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }} />
                </IconButton>
              </Box>
            </Box>
            <Box
              textAlign="center"
              sx={{ margin: "auto", width: "150px", bgcolor: "black", border: `1px solid #999999`, borderRadius: "5px", position: "relative", zIndex: 2, top: 12 }}
            >
              <Typography variant="button" color="#999999" fontSize="12px">
                League settings
              </Typography>
            </Box>
            <Grid
              container
              spacing={0}
              margin="auto"
              mb={2}
              sx={{
                borderRadius: "5px",
                overflow: "hidden",
                border: `1px solid #999999`,
                width: "90%",
                textAlign: "center",
              }}
            >
              {informationPartners.map((infoPartner, index) => (
                <Grid key={index} item xs={2}>
                  <Card
                    sx={{
                      backgroundColor: `#222222`,
                      height: "50px !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 0,
                      boxShadow: "none",
                      borderLeft: index !== 0 ? "0.5px dashed #999999" : "none",
                      borderRight: index !== informationPartners.length - 1 ? "0.5px dashed #999999" : "none",
                    }}
                  >
                    <CardContent
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        padding: 0,
                      }}
                    >
                      <Typography
                        variant="h5"
                        p={1}
                        color={
                          infoPartner.cardsOn !== undefined
                            ? infoPartner.cardsOn == true
                              ? `${PureLightThemeCaaS.colors.alpha.white[100]}`
                              : `#999999`
                            : `${PureLightThemeCaaS.colors.alpha.white[100]}`
                        }
                      >
                        {infoPartner.text}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

            {/* Render analyze trade button if user selected at least one item from each table */}
            {isTradeReady ? (
              <>
                {/*
                <TradeCreditOptionButton
                  onClick={handleTradeResponseOpen}
                  hasCachedData={isTradeDataValidForDisplay(tradeResponseData)}
                  selectedModel={selectedModel}
                  setSelectedModel={setSelectedModel}
                />
                */}
                <Button
                  onClick={() => handleTradeResponseOpen()}
                  variant="contained"
                  sx={{
                    bgcolor: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                    borderRadius: 0.5,
                    width: "90%",
                    height: "45px",
                    textAlign: "center",
                    margin: "auto",
                    mb: 0.6,
                    gap: 1,
                  }}
                >
                  ANALYZE TRADE
                  {/* Credits box */}
                  <CreditsValueButtons credits={agentEndpointCredits} isCreditsAnimating={isCreditsAnimating} creditsBoxRef={creditsBoxRef} creditBoxSize={14} creditBoxColor={PureLightThemeCaaS.colors.alpha.white[100]} isNewRunButton={true} />
                </Button>
              </>
            ) : (
              <Button variant="contained" sx={{ bgcolor: "#555555", height: "45px", borderRadius: 0.5, width: "90%", textAlign: "center", margin: "auto", mb: 0.6 }}>
                CLICK PLAYER NAME TO ADD TO TRADE
              </Button>
            )}

            <Grid container spacing={0}>
              <Grid item xs={6} pl={3} pr={1}>
                <Typography variant="h5" p={1} textAlign="center" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} className={styles.dataTitle}>
                  Your Team
                </Typography>
                <Box borderTop={"1px solid white"} mr={0}></Box>

                <TableContainer sx={{ overflowX: "hidden", overflowY: "auto" }}>
                  <Table sx={{ bgcolor: `${PureLightThemeCaaS.colors.alpha.black[100]}` }}>
                    <TableBody>
                      {/* Render players in the table */}
                      {rostersData?.user_team &&
                        rostersData?.user_team.players.map((player) => {
                          return (
                            <TableRow
                              key={player.player_id}
                              onClick={() => handleClickFirstRow(player)}
                              style={{
                                borderRight: "2px solid #000000",
                                textAlign: "center",
                                height: "40px",
                                backgroundColor: selectedFirstRow.some((p) => p.player_id === player.player_id) ? "#FFD1C0" : "#000000",
                              }}
                            >
                              <Stack pl={0.5}>
                                <TableCell
                                  sx={{
                                    p: 0,
                                    color: selectedFirstRow.some((p) => p.player_id === player.player_id)
                                      ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                      : `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                                    borderBottom: "none",
                                  }}
                                >
                                  <Typography
                                    className={styles.dataTable}
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {isMobile ? getNameWithSuspensivePoints(player?.name) : player?.name}
                                  </Typography>
                                </TableCell>
                              </Stack>
                              <Stack
                                sx={{
                                  "& > :not(style) ~ :not(style)": {
                                    marginTop: 0,
                                  },
                                }}
                                width="100%"
                                pr={0.5}
                                pl={1}
                                pb={0.5}
                                display="flex"
                                flexDirection="row"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <TableCell
                                  sx={{
                                    p: 0,
                                    fontSize: "12px",
                                    color: selectedFirstRow.some((p) => p.player_id === player.player_id)
                                      ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                      : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                    borderBottom: "none",
                                    width: "33.33%",
                                  }}
                                  className={styles.dataTable}
                                >
                                  {player.team}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    p: 0,
                                    fontSize: "12px",
                                    textAlign: "center",
                                    color: selectedFirstRow.some((p) => p.player_id === player.player_id)
                                      ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                      : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                    borderBottom: "none",
                                    width: "33.33%",
                                  }}
                                  className={styles.dataTable}
                                >
                                  {player.position}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    p: 0,
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    textAlign: "end",
                                    color: selectedFirstRow.some((p) => p.player_id === player.player_id)
                                      ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                      : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                    borderBottom: "none",
                                    width: "33.33%",
                                  }}
                                  className={styles.dataTable}
                                >
                                  {/* {Math.round(player.player_value)} */}
                                  {/* {parseFloat(Number(player.player_value).toFixed(1))} */}
                                  {formatValue(player.player_value)}
                                </TableCell>
                              </Stack>
                            </TableRow>
                          );
                        })}

                      {/* Render draft picks in the table (dynasty/keeper only; hidden for redraft) */}
                      {!isLeagueTypeRedraft &&
                        rostersData?.user_team &&
                        rostersData?.user_team.draft_picks &&
                        rostersData?.user_team.draft_picks.map((pick, index) => (
                          <TableRow
                            key={`draft_pick_${pick.id}`}
                            onClick={() => handleClickFirstRow(pick)}
                            style={{
                              borderRight: "2px solid #000000",
                              height: "40px",
                              backgroundColor: selectedFirstRow.some((p) => p.id === pick.id) ? "#FFD1C0" : "#000000",
                            }}
                          >
                            <Stack pl={0.5}>
                              <TableCell
                                sx={{
                                  p: 0,
                                  fontSize: "14px",
                                  color: selectedFirstRow.some((p) => p.id === pick.id)
                                    ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                    : `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                                  borderBottom: "none",
                                  fontWeight: "bold",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: "100%",
                                }}
                                className={styles.dataTable}
                              >
                                {isMobile ? getNameWithSuspensivePoints(pick.name) : pick.name}
                              </TableCell>
                            </Stack>
                            <Stack
                              sx={{
                                "& > :not(style) ~ :not(style)": {
                                  marginTop: 0,
                                },
                              }}
                              width="100%"
                              pr={0.5}
                              pl={1}
                              pb={0.5}
                              display="flex"
                              flexDirection="row"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <TableCell
                                sx={{
                                  p: 0,
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                  color: selectedFirstRow.some((p) => p.id === pick.id)
                                    ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                    : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                  borderBottom: "none",
                                  width: "33.33%",
                                }}
                                className={styles.dataTable}
                              >
                                -
                              </TableCell>
                              <TableCell
                                sx={{
                                  p: 0,
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  color: selectedFirstRow.some((p) => p.id === pick.id)
                                    ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                    : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                  borderBottom: "none",
                                  width: "33.33%",
                                }}
                                className={styles.dataTable}
                              >
                                -
                              </TableCell>
                              <TableCell
                                sx={{
                                  p: 0,
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  textAlign: "end",
                                  color: selectedFirstRow.some((p) => p.id === pick.id)
                                    ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                    : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                  borderBottom: "none",
                                  width: "33.33%",
                                }}
                                className={styles.dataTable}
                              >
                                {/* {pick.draft_pick_value} */}
                                {/* {parseFloat(Number(pick.draft_pick_value).toFixed(1))} */}
                                {formatValue(pick.draft_pick_value)}
                              </TableCell>
                            </Stack>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              <Grid item xs={6} pr={3} pl={1}>
                <Typography variant="h5" p={1} textAlign="center" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} className={styles.dataTitle}>
                  Trade Partner
                </Typography>
                <Box borderTop={"1px solid white"} ml={0}></Box>

                <TableContainer sx={{ overflowX: "hidden", overflowY: "auto" }}>
                  <Table sx={{ bgcolor: `${PureLightThemeCaaS.colors.alpha.black[100]}` }}>
                    <TableBody>
                      {selectedCompetitorTeam &&
                        selectedCompetitorTeam.players.map((player) => {
                          // const [firstName, lastName] = player.name ? player.name.split(" ") : ["", ""];
                          return (
                            <TableRow
                              key={player.player_id}
                              onClick={() => handleClickSecondRow(player)}
                              style={{
                                borderLeft: "2px solid #000000",
                                textAlign: "center",
                                height: "40px",
                                backgroundColor: selectedSecondRow.some((p) => p.player_id === player.player_id) ? "#FFD1C0" : "#000000",
                              }}
                            >
                              <Stack pr={0.5}>
                                <TableCell
                                  sx={{
                                    p: 0,
                                    color: selectedSecondRow.some((p) => p.player_id === player.player_id)
                                      ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                      : `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                                    borderBottom: "none",
                                  }}
                                >
                                  <Typography
                                    pl={0.5}
                                    className={styles.dataTable}
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {getNameWithSuspensivePoints(player.name)}
                                  </Typography>
                                </TableCell>
                              </Stack>
                              <Stack
                                sx={{
                                  "& > :not(style) ~ :not(style)": {
                                    marginTop: 0,
                                  },
                                }}
                                width="100%"
                                pl={0.5}
                                pr={1}
                                pb={0.5}
                                display="flex"
                                flexDirection="row"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <TableCell
                                  sx={{
                                    p: 0,
                                    fontSize: "12px",
                                    textAlign: "left",
                                    color: selectedSecondRow.some((p) => p.player_id === player.player_id)
                                      ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                      : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                    borderBottom: "none",
                                    width: "33.33%",
                                  }}
                                  className={styles.dataTable}
                                >
                                  {player.team}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    p: 0,
                                    fontSize: "12px",
                                    textAlign: "center",
                                    color: selectedSecondRow.some((p) => p.player_id === player.player_id)
                                      ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                      : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                    borderBottom: "none",
                                    width: "33.33%",
                                  }}
                                  className={styles.dataTable}
                                >
                                  {player.position}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    p: 0,
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    textAlign: "end",
                                    color: selectedSecondRow.some((p) => p.player_id === player.player_id)
                                      ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                      : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                    borderBottom: "none",
                                    width: "33.33%",
                                  }}
                                  className={styles.dataTable}
                                >
                                  {/* {Math.round(player.player_value)} */}
                                  {/* {parseFloat(Number(player.player_value).toFixed(1))} */}
                                  {formatValue(player.player_value)}
                                </TableCell>
                              </Stack>
                            </TableRow>
                          );
                        })}
                      {/* Render draft picks in the table (dynasty/keeper only; hidden for redraft) */}
                      {!isLeagueTypeRedraft &&
                        selectedCompetitorTeam &&
                        selectedCompetitorTeam.draft_picks &&
                        selectedCompetitorTeam.draft_picks.map((pick, index) => (
                          <TableRow
                            key={`draft_pick_${pick.id}`}
                            onClick={() => handleClickSecondRow(pick)}
                            style={{
                              borderRight: "2px solid #000000",
                              height: "40px",
                              backgroundColor: selectedSecondRow.some((p) => p.id === pick.id) ? "#FFD1C0" : "#000000",
                            }}
                          >
                            <Stack pr={0.5}>
                              <TableCell
                                sx={{
                                  p: 0,
                                  fontSize: "14px",
                                  color: selectedSecondRow.some((p) => p.id === pick.id)
                                    ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                    : `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                                  borderBottom: "none",
                                  fontWeight: "bold",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: "100%",
                                }}
                                className={styles.dataTable}
                              >
                                {getNameWithSuspensivePoints(pick.name)}
                              </TableCell>
                            </Stack>
                            <Stack
                              sx={{
                                "& > :not(style) ~ :not(style)": {
                                  marginTop: 0,
                                },
                              }}
                              width="100%"
                              pl={0.5}
                              pr={1}
                              pb={0.5}
                              display="flex"
                              flexDirection="row"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <TableCell
                                sx={{
                                  p: 0,
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                  color: selectedSecondRow.some((p) => p.id === pick.id)
                                    ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                    : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                  borderBottom: "none",
                                  width: "33.33%",
                                }}
                                className={styles.dataTable}
                              >
                                -
                              </TableCell>
                              <TableCell
                                sx={{
                                  p: 0,
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  color: selectedSecondRow.some((p) => p.id === pick.id)
                                    ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                    : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                  borderBottom: "none",
                                  width: "33.33%",
                                }}
                                className={styles.dataTable}
                              >
                                -
                              </TableCell>
                              <TableCell
                                sx={{
                                  p: 0,
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  textAlign: "end",
                                  color: selectedSecondRow.some((p) => p.id === pick.id)
                                    ? `${PureLightThemeCaaS.colors.alpha.black[100]}`
                                    : `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                                  borderBottom: "none",
                                  width: "33.33%",
                                }}
                                className={styles.dataTable}
                              >
                                {/* {pick.draft_pick_value} */}
                                {/* {parseFloat(Number(pick.draft_pick_value).toFixed(1))} */}
                                {formatValue(pick.draft_pick_value)}
                              </TableCell>
                            </Stack>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Stack>
        )
      ) : !isGeneratingResult ? (
        <LoaderFacts
          onClose={handleDrawerClose}
          goBack={goBack}
          showExpandToggle={Boolean(aiSettings?.quan)}
          isExpanded={isExpanded}
          onToggleExpand={onToggleExpand}
        />
      ) : (
        <TradeResponseStream
          handleTradeResponseOpen={handleTradeResponseOpen}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          goBack={handleTradeResponseClose}
          onCloseModal={handleCloseTradeModal}
          tradeResponseData={tradeResponseData}
          userDataPlatform={userDataPlatform}
          givePlayers={givePlayers}
          receivePlayers={receivePlayers}
          setShouldPlayAudio={setShouldPlayAudio}
          isGeneratingResult={isGeneratingResult}
          isWaitingForChart={isWaitingForChart}
          tradeAudioUrl={tradeAudioUrl}
          hasLiveTradeAudio={hasLiveTradeAudio}
          setIsPaymentOpen={setIsPaymentOpen}
          setInitialPaymentView={setInitialPaymentView}
          isExpanded={isExpanded}
          onToggleExpand={onToggleExpand}
          characterRef={characterRef}
          creditsBoxRef={creditsBoxRef}
          isCreditsAnimating={isCreditsAnimating}
        />
      )}

      {/* Rate Limit Drawer - self-contained, opens when the user exceeds 30 req/min */}
      <RateLimitDrawer
        open={isRateLimitDrawerOpen}
        onClose={() => setIsRateLimitDrawerOpen(false)}
        retryAt={rateLimitRetryAt}
      />
    </div>
  );
}

export default TradeGiveReceiveStream;
